// What a row of the `subscriptions` table means for access. The same rule is
// applied by the app and described on the Free and Pro page.

// 'past_due' keeps access while the payment processor retries a failed card.
const ACTIVE_STATUSES = ['active', 'trialing', 'past_due'];

// The free trial is offered once. Any status other than 'none' means the
// account has subscribed before (create-checkout applies the same rule from
// the stored subscription).
export const trialAvailable = (row) => !row || !row.status || row.status === 'none';
export const plansFor = (plans, row) => (trialAvailable(row) ? plans : plans.map(({ trial, ...plan }) => plan));
// Pro given by hand, not bought: 'owner' for the owner's own account, 'granted'
// for one given from the admin Users view. There is nothing to bill or receipt.
export const isComplimentary = (row) => !!row && row.status === 'lifetime' && ['owner', 'granted'].includes(row.plan);

// A renewal notice can arrive a little after the period ends.
const GRACE_MS = 3 * 24 * 60 * 60 * 1000;

export function isProSubscription(row, now = Date.now()) {
  if (!row) return false;
  if (row.status === 'lifetime') return true;
  if (!ACTIVE_STATUSES.includes(row.status)) return false;
  if (!row.current_period_end) return true;
  const end = new Date(row.current_period_end).getTime();
  return !Number.isFinite(end) || end + GRACE_MS > now;
}

/** One line for the Free and Pro page: what the person has and what happens next. */
export function describeSubscription(row, now = Date.now()) {
  if (!isProSubscription(row, now)) return '';
  // Granted by hand (the owner's own account), not bought.
  if (isComplimentary(row)) return 'Complimentary. It does not expire.';
  if (row.status === 'lifetime') return 'One-time purchase. It does not renew and does not expire.';
  const date = row.current_period_end
    ? new Date(row.current_period_end).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })
    : '';
  if (row.cancel_at_period_end) return date ? `Cancelled. Pro stays active until ${date}.` : 'Cancelled. Pro stays active until the end of the paid period.';
  if (row.status === 'trialing') return date ? `Free trial. The first payment is taken on ${date} unless you cancel before then.` : 'Free trial.';
  if (row.status === 'past_due') return 'The last payment did not go through. Update your card under Manage subscription to keep Pro.';
  return date ? `Renews on ${date}.` : 'Active.';
}
